// GENERATED FILE - DO NOT MODIFY

export enum GetFoodCategoriesSortColumnDto {
    Order = "Order",
    Name = "Name",
}